// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"bc83b074655181fb","5809":"b7352dabb2265bf0"}[chunkId] + ".css";
};